import { formatCurrency } from "@/utils/currency-formatter";
import { getDateFormat } from "@/utils/date-format";
import { ColumnProps } from "@monolith-forensics/monolith-ui";
import moment from "moment";

const EquipmentColumnDefs: ColumnProps[] = [
  {
    dataField: "asset_number",
    caption: "Asset Number",
  },
  {
    dataField: "barcode",
    caption: "Barcode",
    visible: false,
  },
  {
    dataField: "vendor",
    caption: "Vendor",
  },
  {
    dataField: "name",
    caption: "Name",
  },
  {
    dataField: "category",
    caption: "Category",
  },
  {
    dataField: "model",
    caption: "Model",
    visible: false,
  },
  {
    dataField: "serial_number",
    caption: "Serial Number",
  },
  {
    dataField: "purchase_date",
    caption: "Purchase Date",
    dataType: "date",
    render: (data) => {
      if (!data?.rowData?.purchase_date) return "";
      // Sets user's preferred date format from localStorage
      const dateFormat = getDateFormat({
        isMoment: true,
        includeTime: false, // We only want the date
      });

      return moment(data.rowData.purchase_date).format(dateFormat);
    },
  },
  {
    dataField: "cost",
    caption: "Cost",
    render: (data) => formatCurrency(data?.rowData?.cost),
  },
  {
    dataField: "location",
    caption: "Location",
  },
  {
    dataField: "description",
    caption: "Description",
    render: (data) => data?.rowData?.description,
    visible: false,
  },
];

export default EquipmentColumnDefs;
